import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as authActions from 'redux/modules/auth';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({ user: state.auth.user }),
  authActions
)
export default class SessionExpired extends Component {
  componentDidMount() {
		/*setTimeout(()=>{
			this.props.history.pushState('/');
			}, 2000);


		this.props.logout()*/
  }
  render() {
    const { t } = this.props;
    return (
      <div className="container">
        <h1>
          {t("sessions.session_expired")}
        </h1>
        {t("sessions.session_expired_desc")}
      </div>
    );
  }
}
